import React from 'react';

const EmptyState = ({
  icon,
  title,
  description,
  action,
  variant = 'default',
  className = ''
}) => {
  const variants = {
    default: {
      container: 'bg-white border border-gray-200',
      icon: 'text-gray-400',
      title: 'text-gray-800',
      description: 'text-gray-600'
    },
    primary: {
      container: 'bg-blue-50 border border-blue-200',
      icon: 'text-blue-400',
      title: 'text-blue-800',
      description: 'text-blue-600'
    },
    success: {
      container: 'bg-green-50 border border-green-200',
      icon: 'text-green-400',
      title: 'text-green-800',
      description: 'text-green-600'
    },
    warning: {
      container: 'bg-yellow-50 border border-yellow-200',
      icon: 'text-yellow-400',
      title: 'text-yellow-800',
      description: 'text-yellow-600'
    }
  };

  const currentVariant = variants[variant];

  return (
    <div className={`flex flex-col items-center justify-center p-8 text-center rounded-lg ${currentVariant.container} ${className}`}>
      {icon && (
        <div className={`mb-4 ${currentVariant.icon}`}>
          {icon}
        </div>
      )}
      
      {title && (
        <h3 className={`mb-2 text-lg font-semibold ${currentVariant.title}`}>
          {title}
        </h3>
      )}
      
      {description && (
        <p className={`mb-6 max-w-md text-sm ${currentVariant.description}`}>
          {description}
        </p>
      )}
      
      {action && (
        <div className="flex flex-col sm:flex-row gap-3">
          {action}
        </div>
      )}
    </div>
  );
};

// Predefined empty states
export const EmptyTrips = ({ onCreateTrip }) => (
  <EmptyState
    icon={
      <svg aria-hidden="true" className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4v16m8-8H4" />
      </svg>
    }
    title="No Trips Yet"
    description="You haven't created any trips yet. Start planning your magical Disney World adventure!"
    action={
      <button
        onClick={onCreateTrip}
        className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition-colors"
      >
        <svg aria-hidden="true" className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        Create New Trip
      </button>
    }
  />
);

export const EmptyClients = ({ onAddClient }) => (
  <EmptyState
    icon={
      <svg aria-hidden="true" className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    }
    title="No Clients Yet"
    description="Start building your client base to create amazing Disney World experiences."
    action={
      <button
        onClick={onAddClient}
        className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition-colors"
      >
        <svg aria-hidden="true" className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        Add Client
      </button>
    }
  />
);

export const EmptySearch = ({ searchTerm }) => (
  <EmptyState
    icon={
      <svg aria-hidden="true" className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    }
    title="No Results Found"
    description={`We couldn't find any trips matching "${searchTerm}". Try adjusting your search terms.`}
    variant="warning"
  />
);

export default EmptyState; 